module.exports = __webpack_public_path__ + "static/media/nine-ball.4e92e424.png";